document.addEventListener("DOMContentLoaded", function () {
  const filterBy = document.getElementById("filter-by");
  let filterByValue = "any";
  const categories = document.getElementById("category");
  const types = document.getElementById("type");
  const activities = Array.from(document.querySelectorAll(".activity"));

  function showAllActivities() {
    activities.forEach((activity) => {
      activity.classList.add("show");
    });
  }

  function hideAllActivities() {
    activities.forEach((activity) => {
      activity.classList.remove("show");
    });
  }

  function getActivitiesByCategory(category) {
    return activities.filter((activity) => {
      return activity.dataset.category === category;
    });
  }

  function getActivitiesByType(type) {
    return activities.filter((activity) => {
      return activity.dataset.type === type;
    });
  }

  function filterActivities(filterByType, value) {
    console.log(value);
    if (filterByType === "any") {
      console.log("filter type is any");
      showAllActivities();
      return;
    }
    if (filterByType === "category") {
      if (value === "any") {
        showAllActivities();
        return;
      } else {
        hideAllActivities();
        const matchingActivities = getActivitiesByCategory(value);
        matchingActivities.forEach((filteredActivity) => {
          filteredActivity.classList.add("show");
        });
      }
      return;
    }
    if (filterByType === "type") {
      if (value === "any") {
        showAllActivities();
        return;
      } else {
        hideAllActivities();
        const matchingActivities = getActivitiesByType(value);
        matchingActivities.forEach((filteredActivity) => {
          filteredActivity.classList.add("show");
        });
      }
      return;
    }
  }

  function resetDependentFilters() {
    categories.value = "any";
    categories.classList.remove("show");
    types.value = "any";
    types.classList.remove("show");
  }

  filterBy.addEventListener("change", function (e) {
    filterByValue = e.currentTarget.value;
    if (filterByValue === "any") {
      resetDependentFilters();
      showAllActivities();
    } else if (filterByValue === "category") {
      categories.value = "any";
      categories.classList.add("show");
      types.value = "any";
      types.classList.remove("show");
    } else {
      types.value = "any";
      types.classList.add("show");
      categories.value = "any";
      categories.classList.remove("show");
    }
  });

  categories.addEventListener("change", function (e) {
    const categoryValue = e.currentTarget.value;
    filterActivities(filterByValue, categoryValue);
  });
  types.addEventListener("change", function (e) {
    const typeValue = e.currentTarget.value;
    filterActivities(filterByValue, typeValue);
  });
});
